<!-- 高频词 听录音选词成句 ：可自定义选择 学习内容 -->
<template>
  <el-form ref="ref_form" :model="interferenceForm" label-width="120px">
    <el-form-item label="页面选项" prop="optionNum">
      <el-radio-group v-model="interferenceForm.optionNum">
        <el-radio :label="2">两个选项</el-radio>
        <el-radio :label="3">三个选项</el-radio>
        <el-radio v-if="!(currentQuizType === '4001' || currentQuizType === '3001' || currentQuizType === '5001') " :label="4">四个选项</el-radio>
      </el-radio-group>
    </el-form-item>
    <div v-for="(item, index) in interferenceForm.dataList" :key="index" class="game-cutline">
      <el-form-item :label="item.parent.wordName">
        <el-checkbox v-model="item.state" :true-label="1" :false-label="0">学习内容{{ index + 1 }}是否选用</el-checkbox>
      </el-form-item>
      <el-form-item :label="'学习内容' + (index + 1)">
        <el-input v-model="item.wordName" disabled style="width: 500px;" />
      </el-form-item>
      <el-form-item v-if="item.state === 1" label="资料库干扰项" :prop="'dataList.' + index + '.interfereIds'">
        <el-select v-model="item.interfereIds" placeholder="请选择" :multiple="currentQuizType !== '4003'" clearable filterable style="width: 500px;">
          <el-option v-for="item2 in interferenceListOptions(item)" :key="item2.id" :label="item2.name" :value="item2.id" :disabled="isOptionsDisable(item, item2)" />
        </el-select>
      </el-form-item>

      <el-form-item v-if="item.state === 1" label="自定义干扰项">
        <el-button type="success" size="small" :disabled="item.interfereCardList.length >= 3" @click="addCustomerInterfereCard(index)">添加干扰项</el-button>
        <br>
        <div v-for="(item3, index3) in item.interfereCardList" :key="index3" class="interfereCard">
          <div class="cont">
            <el-form-item label="单词" label-width="60px" style="margin-bottom: 10px;">
              <el-input v-model="item3.wordName" maxlength="20" placeholder="请输入单词名称" />
            </el-form-item>
            <el-form-item label="卡片图" label-width="60px">
              <themeUploadAvatar code="customImg" :file-list.sync="item3.imgFile" />
            </el-form-item>
          </div>
          <el-button type="warning" size="small" @click="deleteCustomerInterfereCard(index, index3)">删除</el-button>
        </div>
      </el-form-item>
    </div>
  </el-form>
</template>

<script>
import _ from 'lodash'
import { mapState } from 'vuex'
import themeUploadAvatar from '../../components/themeUploadAvatar'
// import uploadList from '@/components/Upload/uploadList.vue'
// import { getDictoryInfoByCode } from '@/api/api_common.js'
import { saveConfData } from '@api/courseManagement/api_quiz'
export default {
  components: {
    themeUploadAvatar
  },
  props: {
    timestamp: {
      type: Number,
      default: 0
    },
    moduleType: {
      type: String,
      default: ''
    },
    currentQuizType: {
      type: String,
      default: ''
    },
    gameList: {
      type: [Array, Object],
      default: function () {
        return []
      }
    },
    interferenceList: {
      type: Array,
      default: function () {
        return []
      }
    },
    interferenceList2: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data () {
    return {
      interferenceForm: {
        optionNum: 2,
        dataList: []
      },
      rules: {
        optionNum: [{ required: true, message: '请选择选项数量', trigger: 'change' }],
        interfereIds: [{ type: 'array', required: true, message: '请选择干扰项', trigger: 'change' }]
      }
    }
  },
  computed: {
    ...mapState('courseStep', ['courseData', 'stepOptions', 'stepActive'])
  },
  watch: {
    gameList: function (val) {
      this.interferenceForm.dataList = []
      this.interferenceForm.optionNum = val[0].optionNum ? val[0].optionNum : 2

      this.gameList.forEach((item, index) => {
        this.interferenceForm.dataList.push({ state: item.state, parent: item.parent, parentId: item.parentId, studyId: item.studyId, wordName: item.wordName, interfereIds: item.interfereIdList, meansType: item.meansType, interfereCardList: [] })

        const interfereCardList = item.interfereCustomMeans ? item.interfereCustomMeans : []
        for (const item2 of interfereCardList) {
          this.interferenceForm.dataList[index].interfereCardList.push({ wordName: item2.wordName, imgFile: [{ name: item2.cardChartName, paramsFileName: item2.cardChartName, paramsUrl: item2.cardChartPath, url: item2.cardChartRootPath }] })
        }
      })
    }
  },
  created () {

  },
  methods: {
    // 根据游戏类型 和 meansType 判断 干扰项取值
    interferenceListOptions (item) {
      // if (this.currentQuizType === '4003') {
      //   return this.interferenceList
      // } else if (this.currentQuizType === '2002') {
      //   return this.interferenceList
      // } else if (item.meansType === '1') {
      //   return this.interferenceList
      // } else {
      //   return this.interferenceList2
      // }

      // 自然拼读 的句型 放到第二个干扰项选项
      if (this.currentQuizType === '4003') {
        return this.interferenceList
      } else {
        if (item.meansType === '4') {
          return this.interferenceList2
        } else {
          return this.interferenceList
        }
      }
    },
    isOptionsDisable (item, item2) {
      let flag = false
      if (this.currentQuizType === '2002' || this.currentQuizType === '4003') {
        if (item.parentId === item2.id) {
          console.log(999)
          flag = true
        } else {
          flag = false
        }
      } else {
        if (item.studyId === item2.id) {
          flag = true
        } else {
          flag = false
        }
      }
      return flag
    },
    addCustomerInterfereCard (index) {
      this.interferenceForm.dataList[index].interfereCardList.push({ wordName: '', imgFile: [] })
    },
    deleteCustomerInterfereCard (index, index3) {
      this.$confirm('是否确认删除干扰项?', '提示', {
        type: 'warning',
        closeOnClickModal: false
      }).then(() => {
        this.interferenceForm.dataList[index].interfereCardList.splice(index3, 1)
      })
    },
    // 验证干扰项 选择必填项
    isValidateOptions () {
      let flag = false
      let checkTotal = 0
      // 高频词模块，听录音选词成句：只针对 选中的学习内容进行判断
      // 至少选中一个复选框，判断 选中之和大于0
      const arr = _.cloneDeep(this.interferenceForm.dataList)
      for (let i = 0; i < arr.length; i++) {
        checkTotal = checkTotal + arr[i].state
        for (var j = 0; j < arr[i].interfereCardList.length; j++) {
          console.log(arr[i].interfereCardList[j].imgFile)
          if (arr[i].state === 1 && (arr[i].interfereCardList[j].wordName === '' || arr[i].interfereCardList[j].imgFile.length === 0)) {
            this.$message.error(`学习内容${i + 1}自定义干扰项信息未填写完整`)
            flag = true
            return flag
          }
        }

        if (arr[i].state === 1 && (arr[i].interfereIds.length + arr[i].interfereCardList.length) !== (this.interferenceForm.optionNum - 1)) {
          this.$message.error(`学习内容${i + 1}干扰项数量与页面选项数不符`)
          flag = true
          return flag
        }
      }
      if (checkTotal === 0) {
        this.$message.error(`请至少选中一条学习内容`)
        flag = true
        return flag
      }
      return flag
    },
    // 保存游戏配置项
    saveGameOptions() {
      this.$refs.ref_form.validate(valid => {
        if (!valid) { return false }
        const arr = _.cloneDeep(this.interferenceForm.dataList)

        // 高频词模块，听录音选词成句：只针对 选中的学习内容进行判断
        // 至少选中一个复选框，判断 选中之和大于0
        // let checkTotal = 0
        // for (var i = 0; i < arr.length; i++) {
        //   checkTotal = checkTotal + arr[i].state
        //   if (arr[i].state === 1 && arr[i].interfereIds.length !== (this.interferenceForm.optionNum - 1)) {
        //     this.$message.error(`学习内容${i + 1}干扰项选择数量与页面选项数不符`)
        //     return false
        //   }
        // }
        // if (checkTotal === 0) {
        //   this.$message.error(`请至少选中一条学习内容`)
        //   return false
        // }

        if (this.isValidateOptions()) {
          return false
        }

        for (const item of arr) {
          item.interfereCustomMeans = item.interfereCardList
          for (const item2 of item.interfereCustomMeans) {
            item2.cardChartName = item2.imgFile[0].paramsFileName
            item2.cardChartPath = item2.imgFile[0].paramsUrl
          }
        }
        const params = {
          curriculumId: this.courseData.teachingCurriculumId,
          curriculumType: this.courseData.curriculumType,
          quizType: this.currentQuizType,

          optionNum: this.interferenceForm.optionNum,
          items: arr
        }

        // if (this.courseData.curriculumType === 'WORDS' || this.courseData.curriculumType === 'REVIEWWORDS') {
        //   _api = saveConfWords
        // } else if (this.courseData.curriculumType === 'PHONICS' || this.courseData.curriculumType === 'REVIEWPHONICS') {
        //   _api = saveConfPhonics
        // } else if (this.courseData.curriculumType === 'READING' || this.courseData.curriculumType === 'REVIEWREADING') {
        //   _api = saveConfReading
        // } else if (this.courseData.curriculumType === 'SIGHTWORDS' || this.courseData.curriculumType === 'REVIEWSIGHTWORDS') {
        //   _api = saveConfSightWords
        // } else if (this.courseData.curriculumType === 'SENTENCE' || this.courseData.curriculumType === 'REVIEWSENTENCE') {
        //   _api = saveConfSentence
        // }

        saveConfData(params).then(res => {
          this.$message.success('操作成功')
          this.$emit('finishSave')
        })
      })
    }
  }
}
</script>

<style lang='scss'>

</style>
